import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
type Faq = {
  question: string;
  answer: string[];
  bullets?: string[];
  closing?: string;
};
const faqs: Faq[] = [{
  question: 'How do I receive Stretching Instructor Ready after purchasing?',
  answer: ['You receive digital access after your purchase is completed.', 'The complete package is delivered as PDF resources that can be accessed from compatible devices.']
}, {
  question: 'Is this an app?',
  answer: ['No.', 'Stretching Instructor Ready is delivered as a digital PDF-based teaching system.']
}, {
  question: 'Does the package contain videos?',
  answer: ['No.', 'The system is based on highly visual PDF teaching resources, movement sequences, progressions and ready-to-teach classes.']
}, {
  question: 'Is the material in English?',
  answer: ['Yes.', 'Stretching Instructor Ready is provided in English.']
}, {
  question: 'Can I edit the files?',
  answer: ['No.', 'The materials are delivered as finished PDF resources.']
}, {
  question: 'Is this only for beginner instructors?',
  answer: ['No.', 'The system can support both newer and experienced stretching instructors.']
}, {
  question: 'Is this only for beginners?',
  answer: ['No.', 'Classes and progressions range from beginner to more advanced levels.']
}, {
  question: 'Do I need special equipment?',
  answer: ['Many classes can be taught with little or no equipment.', 'Individual sessions may include optional support tools depending on the objective.']
}, {
  question: 'Are all 150 classes the same type of stretching?',
  answer: ['No.', 'The complete system covers foundations, lower body, upper body, dynamic stretching, active mobility, recovery, full-body work and progressive programming.']
}, {
  question: 'Can I use only the classes that fit my teaching style?',
  answer: ['Yes.', 'You can choose classes according to your clients, schedule, focus and teaching objectives.']
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-t border-primary/10 bg-background px-4 py-20 sm:py-28" data-id="element-100" data-mp="2azk6jnoffjbr">
      <div className="mx-auto max-w-3xl" data-id="element-101" data-mp="38k6cowvap8kz">
        <div className="text-center" data-id="element-102" data-mp="33meoactv04lj">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-103" data-mp="33ng04jip8v4b">
            FAQ
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-foreground sm:text-4xl" data-id="element-104" data-mp="2ylqlyv06k1c0">
            Frequently Asked <span className="italic text-primary" data-id="element-105" data-mp="2ul6pltnfl1qx">Questions</span>
          </h2>
        </div>
        <div className="mt-12 space-y-3" data-id="element-106" data-mp="1n8y1m59pyf5z">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-lg border border-primary/20 bg-surface" data-id="element-107" data-mp="3uu6fu3oyegfs" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left transition-colors duration-150 hover:bg-surface-subtle focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary" data-id="element-108" data-mp="2qdneaobnrrq">
                  <span className="text-base font-semibold text-foreground" data-id="element-109" data-mp="qfora10yy2a3">
                    {faq.question}
                  </span>
                  <ChevronDownIcon size={20} aria-hidden="true" className={`shrink-0 text-primary transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-110" data-mp="vdqcoslvadoq" />
                </button>
                <AnimatePresence initial={false} data-id="element-111" data-mp="21vptre3w1mjm">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-112" data-mp="21xspmerq29w9">
                      <div className="space-y-2 border-t border-primary/15 px-6 py-5 text-sm leading-6 text-muted-foreground" data-id="element-113" data-mp="1j58f2dfw4rh9">
                        {faq.answer.map(paragraph => <p key={paragraph} data-id="element-114" data-mp="1e4kfv4hid4by">{paragraph}</p>)}
                        {faq.bullets && <ul className="list-disc space-y-1 pl-5 marker:text-primary" data-id="element-115" data-mp="1o4b8t1qf7b9x">
                            {faq.bullets.map(bullet => <li key={bullet} data-id="element-116" data-mp="10cw1svnp85sc">{bullet}</li>)}
                          </ul>}
                        {faq.closing && <p data-id="element-117" data-mp="3727tpgr95khj">{faq.closing}</p>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}